import Lottie from 'lottie-react';

import json from '../jsons/questionnaire-hover-pinch.json';

const QuestionnaireAnimated = props => {
  return <Lottie loop={false} animationData={json} {...props} />;
};

export default QuestionnaireAnimated;
